var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-window"},[(_vm.royalTree)?_c('p',{staticClass:"text-royal-tree"},[_vm._v("ต้นไม้พระราชทาน")]):_vm._e(),_c('v-lazy-image',{staticClass:"info-img",attrs:{"src":_vm.imageUrl,"src-placeholder":_vm.imageUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }